import type {
  ConfidenceCheckerBriefAnalysisFile,
  ConfidenceCheckerSummaryEvaluationItem,
} from "@nlc/shared-types";

import { ConfidenceCheckerEvaluationCard } from "./ConfidenceCheckerEvaluationCard";

interface ConfidenceCheckerBriefAnalysisFilesProps {
  evaluations: ConfidenceCheckerSummaryEvaluationItem[];
  files: ConfidenceCheckerBriefAnalysisFile[];
  onPreview?: (attachmentId: string) => void;
}

export function ConfidenceCheckerBriefAnalysisFiles({
  evaluations,
  files,
  onPreview,
}: ConfidenceCheckerBriefAnalysisFilesProps) {
  const label = `${files.length} ${files.length === 1 ? "file" : "files"} evaluated`;

  const evaluationsByAttachmentId = new Map(
    evaluations.map((item) => [item.attachment.id, item]),
  );

  return (
    <div className="flex flex-col gap-2.5">
      <span className="text-xs font-semibold uppercase tracking-wider text-text-quaternary">
        {label}
      </span>

      {files.length > 0 && (
        <div className="flex flex-col gap-2">
          {files.map((file) => {
            const item = evaluationsByAttachmentId.get(file.attachmentId);

            if (!item) return null;

            return (
              <ConfidenceCheckerEvaluationCard
                attachment={item.attachment}
                designerName={item.designerName}
                evaluation={item.evaluation}
                isDelivered={item.isDelivered}
                key={file.attachmentId}
                onPreview={onPreview}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
